import { useCallback, useEffect } from "react";

import { useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";

import { useInboundStore } from "flows/Inbound/stores/inboundStore/useInboundStore";
import { useOutboundClaimedProduct } from "flows/Inbound/stores/useOutboundClaimedProduct";
import { isNullOrUndefined } from "utils/tsHelpers";

import { InboundEditQuantity } from "./InboundEditQuantity";

export function InboundEditQuantityPage() {
  const navigate = useNavigate();

  const { outboundSku, claimedProductsMap, claimedProductsStockUpdates } = useInboundStore(
    useShallow((state) => ({
      outboundSku: state.outboundClaimedSku,
      claimedProductsMap: state.claimedProductsMap,
      claimedProductsStockUpdates: state.claimedProductsStockUpdates,
    })),
  );
  const { updateStock, isStockUpdating } = useOutboundClaimedProduct();
  const inboundUnitData = claimedProductsMap[outboundSku || ""];
  const isInvalidParams = isNullOrUndefined(outboundSku) || isNullOrUndefined(inboundUnitData);

  const returnToInboundHomePage = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  useEffect(() => {
    if (isInvalidParams) {
      returnToInboundHomePage();
    }
  }, [isInvalidParams, returnToInboundHomePage]);

  if (isInvalidParams) {
    return null;
  }

  const { shelfLetter, shelfNumber, productImageUrl, productName, productSku } = inboundUnitData;
  const inboundUnitStockUpdatePlan =
    claimedProductsStockUpdates[outboundSku || ""]?.stockUpdatePlan;

  return (
    <InboundEditQuantity
      outboundSku={outboundSku}
      shelfLetter={shelfLetter}
      shelfNumber={shelfNumber}
      productSku={productSku}
      productName={productName}
      productImageUrl={productImageUrl}
      stockUpdatePlan={inboundUnitStockUpdatePlan}
      isStockUpdating={isStockUpdating}
      updateStock={updateStock}
      returnToInboundHomePage={returnToInboundHomePage}
    />
  );
}
